import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import ListSegment from './submodules/list';
import EditSegment from './submodules/edit';
import ViewSegment from './submodules/view';
import CreateSegment from './submodules/create';
import scheduleSegment from './submodules/schedule';
import EvaluateSegment from './submodules/evaluate';

const ListSegmentDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].listSegment]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListSegment}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateSegment]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditSegment}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].schedule]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/schedule`}
				component={scheduleSegment}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].viewSegment]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/view`}
				component={ViewSegment}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].createSegment]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateSegment}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].activateSegment]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/evaluate`}
				component={EvaluateSegment}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default ListSegmentDashboard;
